import React, { useContext } from 'react'
import { CarOrderingContext } from "../CarOrdering";
import Step1 from "./Main/Steps/Step1";
import Step2 from "./Main/Steps/Step2";
import StepCheckout from "./Main/Steps/StepCheckout";

export default function Main() {
  const {
    currentStep,
    steps,
  } = useContext(CarOrderingContext)

  if (steps.length < 2) {
    return null
  }

  if (currentStep.isCheckout) {
    return (
      <main>
        <StepCheckout />
      </main>
    )
  }

  if (currentStep.id === 1) {
    return (
      <main>
        <Step1 />
      </main>
    )
  }

  if (currentStep.id === 2) {
    return (
      <main>
        <Step2 />
      </main>
    )
  }
}
